import { get } from "../../utils/object-helpers";
import { getTracking } from "./util";

<if(input.pages.length > 1)>
    <div class="str-pagination" key="str-pagination">
        <ebay-pagination
            onSelect("fetchPage")
            onPrevious("fetchPage")
            onNext("fetchPage")
            variant="show-last"
            a11y-previous-text=input.prevText
            a11y-next-text=input.nextText
            a11y-current-text=input.currText
        >
            <!-- Previous button/link -->
            <@item
                type="previous"
                href=input.prevUrl
                disabled=(input.prevUrl ? false : true)
                aria-label=input.prevText
                data-track=input.prevTrack
            />
            <!-- Page links -->
            <for|page| of=input.pages>
                $ {
                    const url = get(page, "action.URL", "");
                    const dataTrack = getTracking(page);
                    const pageNumText = get(page, "text", "");
                    const a11yText = get(page, "accessibilityText", "");
                    const current = get(page, "selected", false);
                }
                <@item
                    href=url
                    aria-label=a11yText
                    data-track=dataTrack
                    current=current
                >
                    ${pageNumText}
                </@item>
            </for>
            <!-- Next button/link -->
            <@item
                type="next"
                href=input.nextUrl
                disabled=(input.nextUrl ? false : true)
                aria-label=input.nextText
                data-track=input.nextTrack
            />
        </ebay-pagination>
        <!-- Items-per-page control -->
        <if(input.ippOptions)>
            <div class="str-pagination__ipp">
                <span id="str-pagination__ipp-label">
                    ${input.ippLabel}
                </span>
                <div class="str-pagination__ipp-menu">
                    <ebay-menu-button
                        aria-labelledby="str-pagination__ipp-label"
                        collapseOnSelect
                        onSelect("fetchPage")
                        reverse="true"
                        text=input.ippCurrOptionText
                        a11yText=input.ippCurrOptionA11yText
                    >
                        <for|option, idx| of=input.ippOptions>
                            $ {
                                const text = get(option, "text", "");
                                const url = get(option, "action.URL", "");
                                const a11yText = get(
                                    option,
                                    "accessibilityText",
                                    ""
                                );
                                const dataTrack = getTracking(option);
                            }
                            <@item
                                key=idx
                                aria-label=a11yText
                                data-track=dataTrack
                                href=url
                            >
                                ${text}
                            </@item>
                        </for>
                    </ebay-menu-button>
                </div>
            </div>
        </if>
    </div>
</if>
